import React from 'react';

type EditActionIconProps = {
  className?: string;
};

export default function EditActionIcon({ className }: EditActionIconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="16"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g clipPath="url(#clip0_519_23934)">
        <path
          d="M18 10H13.3333C12.9797 10 12.6406 10.1405 12.3905 10.3905C12.1405 10.6406 12 10.9797 12 11.3333V20.6667C12 21.0203 12.1405 21.3594 12.3905 21.6095C12.6406 21.8595 12.9797 22 13.3333 22H22.6667C23.0203 22 23.3594 21.8595 23.6095 21.6095C23.8595 21.3594 24 21.0203 24 20.6667V16"
          stroke="#213F39"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2504 9.75015C22.5156 9.48493 22.8753 9.33594 23.2504 9.33594C23.6255 9.33594 23.9852 9.48493 24.2504 9.75015C24.5156 10.0154 24.6646 10.3751 24.6646 10.7502C24.6646 11.1252 24.5156 11.4849 24.2504 11.7502L18.2417 17.7595C18.0834 17.9176 17.8879 18.0334 17.6731 18.0962L15.7577 18.6562C15.7004 18.6729 15.6395 18.6739 15.5817 18.6591C15.5238 18.6442 15.4709 18.6141 15.4287 18.5719C15.3864 18.5296 15.3563 18.4768 15.3415 18.4189C15.3267 18.361 15.3277 18.3002 15.3444 18.2428L15.9044 16.3275C15.9674 16.1129 16.0834 15.9175 16.2417 15.7595L22.2504 9.75015Z"
          stroke="#213F39"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_23934">
          <rect width="16" height="16" fill="white" transform="translate(10 8)" />
        </clipPath>
      </defs>
    </svg>
  );
}
